<!-- DateTimePickerNoTZ.vue -->
<script setup lang="ts">
    import DatePickerNoTZ from '../DatePickerNoTZ.vue';
    import { NoTzDate, splitIntoDateAndTimeParts } from '../../lib/DateUtils';
    import { watch, reactive, computed, onMounted, ref } from 'vue';

    const props = withDefaults(defineProps<{
        modelValue?: NoTzDate,
        showSeconds?:boolean,
        showMilitayTime?: boolean,
        showTimeOnly?: boolean,
        timeClass?: string,
        cssFramework?: "bootstrap" | "vanilla",
        colClassDate?: string,
        colClassTime?: string,
        disabled?: boolean
    }>(), {
        showSeconds: true,
        showMilitayTime: false,
        showTimeOnly: false,
        cssFramework: "bootstrap",
        colClassDate: "col-sm-6",
        colClassTime: "col-sm-6",
        disabled: false
    });

    const emits = defineEmits<{
        "update:modelValue": [value:string]
    }>();

    defineExpose({ focus });

    const compData = reactive<{
        hasBeenSplit?:boolean
        dateNoTz?: NoTzDate,
        time?: string,
    }>({
        dateNoTz: "",
        time: ""
    });

    const datePicker = ref();

    onMounted(() =>{
        updateDateTimeReactiveValues();
    });

    watch(() => props.modelValue, (_newVal, _oldVal) => {
        updateDateTimeReactiveValues();
    });

    watch(() => compData.time, (_newVal, _oldVal) => {
        emitValue();
    });
    watch(() => compData.dateNoTz, (_newVal, _oldVal) => {
        emitValue();
    });

    function updateDateTimeReactiveValues(): void {
        compData.hasBeenSplit = true;
        const splitValues = splitIntoDateAndTimeParts(props.modelValue);
        if (!splitValues)
        {
            compData.time = "";
            return;
        }

        let hours = splitValues.hours;
        if (false === splitValues.am)
        {
            hours += 12; 
        }
        
        compData.time = `${timePartStr(hours)}:${timePartStr(splitValues.minutes)}:${timePartStr(splitValues.seconds)}`;
        compData.dateNoTz = splitValues.dateNoTz;
    }

    function timePartStr(timePart:number)
    {
        if (timePart < 10)
            return "0" + timePart;
        return timePart;
    }


    function emitValue()
    {
        if (!compData.hasBeenSplit)
            return;

        emits("update:modelValue", `${compData.dateNoTz} ${compData.time}`);
    }

    function focus()
    {
        datePicker.value?.focus();
    }
</script>

<style scoped>
    .timeInput
    {
        width: 3em;
    }
    .timeInputCol
    {
        width: 3.5em;
    }

</style>

<template>
    <div class="row row row-cols-lg-auto">
        <div v-if="!props.showTimeOnly" :class="props.colClassDate">
            <DatePickerNoTZ ref="datePicker" :cssFramework="props.cssFramework" :disabled="props.disabled" v-model:value="compData.dateNoTz" />
        </div>
        <div :class="props.colClassTime">
            <input type="time" class="form-control" :disabled="props.disabled" :class="props.timeClass || ''" :cssFramework="props.cssFramework" v-model="compData.time" />
        </div>
    </div>
</template>